var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14.001"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.97 5.315c.231-.216.431-.4.621-.585q2.007-2 4.012-4.009a4.371 4.371 0 01.542-.5 1.149 1.149 0 011.5.125 1.117 1.117 0 01.119 1.5 4.5 4.5 0 01-.5.542q-2 2.007-4.009 4.012c-.19.191-.371.392-.591.624.214.228.393.429.584.619l3.949 3.955a4.385 4.385 0 01.5.543 1.166 1.166 0 01-.086 1.442 1.119 1.119 0 01-1.49.186 3.843 3.843 0 01-.546-.494q-1.977-1.977-3.949-3.957c-.192-.194-.346-.424-.548-.675-.277.248-.464.4-.633.569q-2.038 2.03-4.071 4.067a4.95 4.95 0 01-.478.451 1.144 1.144 0 01-1.565-.08 1.189 1.189 0 01-.066-1.575 5.142 5.142 0 01.457-.473c1.317-1.318 2.631-2.638 3.955-3.949a7.783 7.783 0 01.676-.535c-.258-.288-.408-.472-.575-.641Q2.748 4.439.712 2.406a3.724 3.724 0 01-.492-.548A1.151 1.151 0 011.787.247a3.405 3.405 0 01.552.488q2.009 2 4.012 4.008c.19.189.393.364.619.572z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "a737beca367534378f0194a23b96db71.svg";
export { SvgClose as ReactComponent };